import Validator from 'validatorjs';
import { VALIDATION } from "../../AppConstants";
import { allFieldsValidationCommon, customErrorMessagesCommon } from "../Validation";

Validator.registerImplicit('need_lienholder', function (this: any, value, requirement, attribute) {
    const vehicle = this.validator.input;
    console.log(vehicle);
    if (true === vehicle.wasSalvaged || false === vehicle.hasLienholder) {
        return true;
    }
    return !!value;
});

const rules = {
    vin: 'required',
    wasSalvaged: 'required',
    lienholder: {
        //name: [{required_if: ['hasLienholder', true] }],
        name: 'need_lienholder',
        //name: ['required_if:hasLienholder,true','required_if:wasSalvaged,false'],
        address: {
            street: 'need_lienholder',
            //street: [{required_if: ['hasLienholder', true, 'wasSalvaged', false] }],
            //city: [{ required_if: ['hasLienholder', true] }],
            city: 'need_lienholder',
            //zipCode: [{ required_if: ['hasLienholder', true] }],
            zipCode: 'need_lienholder',
            //stateCode: [{ required_if: ['hasLienholder', true] }]
            stateCode: 'need_lienholder'
        }
    },
    garagingAddress: {
        street: 'required',
        city: 'required',
        zipCode: 'required',
        stateCode: 'required',
    }
};

const customErrorMessages = {
    "need_lienholder": VALIDATION.REQUIRED
};

export const allFieldsValidation = (data) => {
    //return allFieldsValidationCommon(data, rules, customErrorMessagesCommon);
    return allFieldsValidationCommon(data, rules, { ...customErrorMessagesCommon, ...customErrorMessages });
};